import sharedModule from "./shared"

export default {
  namespaced: true,
  ...sharedModule,
}
